

import { httpRequest } from "../../http";
import {LoginInfoSerializer} from "@models/serializers/loginInfoSerializer.ts";

export class CmdTokenLogin {

    async run(token: string) {
        const data = {
            token
        };
        try {
           const response = await httpRequest<any>(`${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/auth/token-login/`, {
                method: "POST",
                body: data,
                auth: true
            });

            return this.deserialize(response);

        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: Record<string,any>) {

        const serializer = new LoginInfoSerializer();
        const loggedInUser = serializer.deserialize(data);

        return loggedInUser;

    }

}

